import React from "react";
import { motion } from "framer-motion";

// Import semua logo
import html from "../assets/html.png";
import css from "../assets/css.png";
import js from "../assets/js.png";
import python from "../assets/python.png";
import php from "../assets/php.png";
import laravel from "../assets/laravel.png";
import reactLogo from "../assets/react.png";
import nodejs from "../assets/nodejs.png";
import express from "../assets/express.png";
import axios from "../assets/axios.png";
import mysql from "../assets/mysql.png";
import postgre from "../assets/postgre.png";
import postman from "../assets/postman.png";
import docker from "../assets/docker.png";
import hostinger from "../assets/hostinger.png";
import aws from "../assets/aws.png";
import figma from "../assets/figma.png";
import github from "../assets/github.png";
import notion from "../assets/notion.png";
import tailwind from "../assets/tailwind.png";

const logosRow1 = [
  html, css, js, python, php, laravel, reactLogo, nodejs, express, figma, github
];
const logosRow2 = [
  axios, mysql, postgre, postman, docker, hostinger, aws, notion, tailwind
];

const SliderRow = ({ logos, reverse }) => {
  return (
    <div className="overflow-hidden w-full relative">
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-surface/30 to-transparent z-10 pointer-events-none"></div>
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-surface/30 to-transparent z-10 pointer-events-none"></div>
      
      <motion.div
        className="flex gap-16 items-center w-max"
        animate={{ x: reverse ? ["-50%", "0%"] : ["0%", "-50%"] }}
        transition={{ repeat: Infinity, duration: 40, ease: "linear" }}
      >
        {[...logos, ...logos].map((logo, idx) => (
          <img
            key={idx}
            src={logo}
            alt="tech"
            className="h-10 md:h-12 w-auto opacity-50 hover:opacity-100 grayscale hover:grayscale-0 transition-all duration-300"
          />
        ))}
      </motion.div>
    </div>
  );
};

const About = () => {
  return (
    <section id="about" className="py-24 px-6 md:px-20 bg-background text-primary relative">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-16"
        >
          <h2 className="text-sm font-semibold tracking-widest text-muted uppercase mb-2">01. About Me</h2>
          <div className="w-12 h-1 bg-accent/50 rounded-full"></div>
        </motion.div>

        <div className="grid md:grid-cols-[1fr_1.5fr] gap-12 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h3 className="text-3xl md:text-4xl font-bold leading-tight tracking-tight mb-4">
              Turning Ideas Into <span className="text-accent font-medium">Digital Reality</span>.
            </h3>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-muted leading-relaxed space-y-6 text-lg font-light"
          >
            <p>
              I am a Fullstack Web Developer based in Bandung with an Informatics
              background, passionate about building accessible and user-friendly
              digital solutions. 
            </p>
            <p>
              I enjoy solving problems through technology and
              continuously exploring new tools and frameworks such as React.js,
              Webflow, and design fundamentals. Beyond coding, I enjoy playing
              football, listening to and creating music, watching films, and
              exploring new knowledge to broaden my perspective.
            </p>
          </motion.div>
        </div>

        {/* Tech Stack */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-50px" }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-24 p-8 md:p-12 rounded-3xl bg-surface/30 border border-white/5 backdrop-blur-sm"
        >
          <h4 className="text-sm font-medium text-muted tracking-widest uppercase mb-10 text-center">
            Technologies I've Worked With
          </h4>

          <div className="space-y-12">
            <SliderRow logos={logosRow1} reverse={false} />
            <SliderRow logos={logosRow2} reverse={true} />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
